import React from 'react';

export const DisqualificationContext = React.createContext({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  disqualificationHandler: (field: string, form: any) => {}
});
